import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ShieldCheck, TrendingUp, Send, Ticket, Users, Mail } from "lucide-react";
import AdminInsightsView from "@/views/AdminInsightsView";
import { DemoRequestsView } from "@/views/DemoRequestsView";
import { SupportTicketsView } from "@/views/SupportTicketsView";
import { AdminUsersView } from "@/views/AdminUsersView";
import { NewsletterSubscribersView } from "@/views/NewsletterSubscribersView";

export default function ManagementView() {
  return (
    <div className="p-4 sm:p-6 max-w-5xl mx-auto">
      <div className="mb-5">
        <h2 className="text-xl font-bold mb-1 flex items-center gap-2" data-testid="management-title">
          <ShieldCheck className="h-5 w-5 text-primary" />Management
        </h2>
        <p className="text-sm text-muted-foreground">Admin control center — growth, leads and support in one place</p>
      </div>
      <Tabs defaultValue="insights">
        <TabsList className="mb-2">
          <TabsTrigger value="insights" data-testid="mgmt-tab-insights"><TrendingUp className="h-4 w-4 mr-1.5" />Growth Insights</TabsTrigger>
          <TabsTrigger value="demo-requests" data-testid="mgmt-tab-demo-requests"><Send className="h-4 w-4 mr-1.5" />Demo Requests</TabsTrigger>
          <TabsTrigger value="support-tickets" data-testid="mgmt-tab-support-tickets"><Ticket className="h-4 w-4 mr-1.5" />Support Tickets</TabsTrigger>
          <TabsTrigger value="users" data-testid="mgmt-tab-users"><Users className="h-4 w-4 mr-1.5" />Users</TabsTrigger>
          <TabsTrigger value="newsletter" data-testid="mgmt-tab-newsletter"><Mail className="h-4 w-4 mr-1.5" />Subscribers</TabsTrigger>
        </TabsList>
        <TabsContent value="insights" className="-mx-4 sm:-mx-6"><AdminInsightsView /></TabsContent>
        <TabsContent value="demo-requests" className="-mx-4 sm:-mx-6"><DemoRequestsView /></TabsContent>
        <TabsContent value="support-tickets" className="-mx-4 sm:-mx-6"><SupportTicketsView /></TabsContent>
        <TabsContent value="users" className="-mx-4 sm:-mx-6"><AdminUsersView /></TabsContent>
        <TabsContent value="newsletter" className="-mx-4 sm:-mx-6"><NewsletterSubscribersView /></TabsContent>
      </Tabs>
    </div>
  );
}
